import React from 'react'

class Footer extends React.Component {
  render() {
    return <div className="footer"></div>
  }
}

export default Footer

